<template>
  <div class="row transaction">
    <div class="spinner-grow" role="status" v-if="loading.show === true"></div>

    <div class="col-auto mt-2">
      <button
        type="submit"
        class="btn btn-primary mb-2 mt-4"
        @click="refresh('none')"
      >
        Refresh
      </button>
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">First Name</th>
                <th scope="col" class="text-center">Last Name</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Wallet Id</th>
                <th scope="col" class="text-center">Amount Requested</th>
                <th scope="col" class="text-center">Request ID</th>
                <th scope="col" class="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(request, index) in requests" :key="request._id">
                <th class="text-center">{{ index + 1 }}</th>
                <td class="text-center">{{ request.firstName }}</td>
                <td class="text-center">{{ request.lastName }}</td>
                <td class="text-center">{{ request.email }}</td>
                <td class="text-center">{{ request.walletId }}</td>
                <td class="text-center">
                  {{ `₦${format.format(request.amount.toFixed(4))}` }}
                </td>
                <td class="text-center">{{ request.requestId }}</td>
                <td class="text-center">
                  <span :class="`p-2 text-white bg-${getColor(request.status)}`"
                    >{{ request.status }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="mt-2 d-flex justify-content-end align-items-center">
      <div class="p-2" v-if="hasPrevPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('previous')"
        >
          Previous Page
        </button>
      </div>
      <div class="p-2" v-if="hasNextPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('next')"
        >
          Next Page
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      error: false,
      requests: [],
      errorMsg: "",
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 50,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
    };
  },
  computed: {
    ...mapState(["loading", "auth"]),
  },
  methods: {
    ...mapActions(["getMerchant", "setNotification"]),
    async refresh(mode) {
      try {
        let payload = { page: this.page };
        switch (mode) {
          case "next":
            payload = { page: this.nextPage };
            break;
          case "previous":
            payload = { page: this.prevPage };
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/funding/request/merchant/fetch-list`,
          { payload },
        );
        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
        } = res.data.requests;
        this.requests = docs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
      } catch (err) {
        console.log(err);
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Requests",
        });
      }
    },
    getColor(status) {
      let color = null;
      switch (status) {
        case "pending":
          color = "info";
          break;
        case "rejected":
          color = "danger";
          break;
        case "approved":
          color = "success";
          break;
      }
      return color;
    },
  },
  async mounted() {
    try {
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/funding/request/merchant/fetch-list`,
        {
          page: this.page,
        },
      );
      const { docs, hasNextPage, hasPrevPage, totalPages, prevPage, nextPage } =
        res.data.requests;
      this.requests = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
    } catch (err) {
      console.log(err);
      this.setNotification({
        type: "danger",
        message: "Unable to Fetch Requests",
      });
    }
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
</style>
